<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import globalStore from "/globalStore.js";
import config from "/config.js";

// The Lotus wordmark + glyph (theme "Logo asset", §2.1). Glyph is the brand
// navy square with the brass initial; wordmark is Poppins 20/700 (§5).
defineProps({
	wordmark: { type: String, default: 'Lotus' },
	glyph: { type: String, default: 'L' },
	eyebrow: { type: String, default: 'PORTAL' },
})

const showGlyph = ref(false);
const showLogo = ref(true);
const logoUrl = ref("/assets/logos/lotus-color.svg");



// Always have an init() that get's called from onMounted()
const init = async () =>
{
	setLogos();
};

const setLogos = () =>
{
	//logoUrl.value = "https://assets.lotusai.co/accounts/logos/7e319d5b-1803-f011-846f-000d3acbbbf9-Valen-imageOnlyFullSizeUrl.png";


	const accountId = globalStore.state.currentUser.activeAccountId;

	if (accountId == "7e319d5b-1803-f011-846f-000d3acbbbf9")
	{
		//-- Valen
		logoUrl.value = config.logo.imageOnlyFullSizeUrl;
	}
}


// Always have onMounted() and it must call init().
onMounted(async () =>
{
	console.log('Component has been mounted to the DOM!');
	await init();
})
</script>

<template>
	<div class="mark">
		<div class="glyph" aria-hidden="true" v-if="showGlyph">
			{{ glyph }}
		</div>
		<div class="logo">
			<img :src="logoUrl" v-if="showLogo">
		</div>
		<div class="txt">
			<div class="wm">
				<a href="/" style="color: inherit; text-decoration: none;">{{ wordmark }}</a>
			</div>
			<div class="eb">
				{{ eyebrow }}
			</div>
		</div>
	</div>
</template>

<style scoped>
.mark
{
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 22px 20px 14px;
	background: inherit;
}

.glyph
{
	width: 30px;
	height: 30px;
	border-radius: var(--r);
	background: var(--brand);
	display: flex;
	align-items: center;
	justify-content: center;
	flex: none;
	font-family: var(--font-display);
	font-weight: 700;
	font-size: var(--text-card);
	color: var(--brand-on);
}

.logo
{
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex: none;
}

.wm
{
	font-family: var(--font-display);
	font-size: 20px;
	font-weight: 700;
	line-height: 1.1;
}

.eb
{
	font-size: 10px;
	font-weight: 500;
	color: var(--accent-text);
	letter-spacing: 3.5px;
}
</style>
